module.exports = __webpack_public_path__ + "img/Master-3.1b8b281e.gif";